import { MICRO_TO_MS } from "../cfg/const";

export function jsonSafeValueToDate (value: number): Date {
  return new Date(value * MICRO_TO_MS)
}

export function jsonSafeValueToMaybeDate (value: number | null) : Date | null {
  if (value == null) return null
  return jsonSafeValueToDate(value)
}